import React from "react";
import ClientForm from "./clientFormWrapper/ClientForm";

export default function ClientFormWrapper({ADD_CLIENT, UPDATE_CLIENT, user, profile}){
    let props = {
        ADD_CLIENT, 
        UPDATE_CLIENT,
        user: user ? user.profile_info : profile
    };
    
    return (
        <ClientForm props={props}/>
    );
}


// WEBPACK FOOTER //
// ./src/components/general/ClientFormWrapper.jsx